import { useEffect } from "react";
import { useLocation } from "wouter";

export default function OAuthCallback() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const errCode = params.get("err_code");

    if (errCode) {
      setLocation("/sign-in?oauth_error=" + encodeURIComponent(errCode), {
        replace: true,
      });
    }
  }, [setLocation]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center text-muted-foreground text-sm">
        Completing sign in…
      </div>
    </div>
  );
}
